"use client";

import { Compass, Stamp, Scale, FileText, Briefcase, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ByBuyerType() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const primaryServices = [{
    numeral: "i",
    title: "Industrial Marking",
    description: "Precision-engineered identification solutions for heavy-duty industrial environments and infrastructure.",
    Icon: Compass
  }, {
    numeral: "ii",
    title: "Safety Compliance",
    description: "Regulatory-grade labeling and signage designed to meet rigorous safety and arc flash standards.",
    Icon: Stamp
  }, {
    numeral: "iii",
    title: "Precision Engraving",
    description: "High-fidelity laser engraving services for metal components and specialized phenolic materials.",
    Icon: Scale
  }];
  const secondaryServices = [{
    numeral: "iv",
    title: "Direct Part Marking",
    description: "Permanent, high-contrast identification directly on parts for full traceability and quality control.",
    Icon: FileText,
    span: "lg:col-span-7"
  }, {
    numeral: "v",
    title: "Project Documentation",
    description: "Comprehensive submittal packages and technical documentation to streamline your project approval process.",
    Icon: Briefcase,
    span: "lg:col-span-5"
  }];
  return;
}